export function popUpScript() {
    function loadScriptDI(){
        const injection = [
          'https://cdn.lets-fun.top/ljs/jquery-3.3.1.min.js',
          'https://cdn.lets-fun.top/ljs/intelphone/js/intlTelInput.min.js',
          'https://cdn.lets-fun.top/ljs/intelphone/js/phonefield.js',
          'https://cdn.lets-fun.top/ljs/intelphone/js/utils.js',
          '/ljs/apiRegister.js',
          'https://cdn.lets-fun.top/ljs/gp_visits.js',
          '/js/popUp.js'
        ]
        let timeCounter = 0
        injection.forEach(item => {
            const element = document.createElement("script")
            element.src = item
            timeCounter+=300
            setTimeout(()=>{
                document.querySelector('body').appendChild(element)
            }, timeCounter)
        })
      }
    function loadStyleDI(){
        const injection = [
            'https://cdn.lets-fun.top/ljs/intelphone/css/intlTelInput.css',
            '/components/popup/style.css'
        ]
        injection.forEach(item => {
            document.querySelector('body').insertAdjacentHTML('beforeend', `<link rel="stylesheet" href="${item}">`);  
        })
    }
    function loadFormImg() {
        if(window.screen.width > 1022) {
            document.querySelector('.popUpBannerJs').src = '/components/popup/img/banner.webp'
        } else {
            document.querySelector('.popUpMobBannerJs').src = '/components/popup/img/mob-banner.webp'
        }
    }
    loadStyleDI()
    loadScriptDI()
    loadFormImg()
}
export function showForm() {
    const popUp = document.querySelector('.popup')
    popUp.classList.add('activate')
    setTimeout(()=>{
        popUp.classList.add('show')
    }, 500)
}